import { render, staticRenderFns } from "./teaBasicInfo.vue?vue&type=template&id=e48cda26"
import script from "./teaBasicInfo.vue?vue&type=script&lang=js"
export * from "./teaBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./teaBasicInfo.vue?vue&type=style&index=0&id=e48cda26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports